export default __webpack_public_path__ + "static/media/8.8a2941b9.jpg";